export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Legal_Alignment-39adc706a6293f79d99038490ecab4b9.svg";